import bookListTypeChange from './ridi.list_view';

$(() => {
  const rollingNotice = () => {
    const aniDuration = 3000;
    const aniStatus = {
      ready: 'ani-ready',
      play: 'ani-play',
    };
    const $noticeItems = $('.jsNoticeItem');
    const itemsCount = $noticeItems.length;
    const rolling = index => {
      $noticeItems.eq(index).addClass(aniStatus.play);
      setTimeout(() => {
        $noticeItems.eq(index).removeClass(aniStatus.play);
        rolling(index + 1 === itemsCount ? 0 : index + 1);
      }, aniDuration);
    };
    if (itemsCount > 1) {
      $noticeItems.addClass(aniStatus.ready).css('animation-duration', `${aniDuration}ms`);
      rolling(0);
    }
  };

  // 상단에 선언된 기능들 호출부.
  bookListTypeChange.init();
  rollingNotice();
});



// WEBPACK FOOTER //
// ./ridi/ridi.common.pc.js